import { Context, useContext } from 'react';
import { FiltersContext, FiltersContextProps } from '../../contexts';
import { FilterConfigWithValue } from '../../types/filter.types';

type ContextProp<T = unknown> = FiltersContextProps<Record<string, FilterConfigWithValue>, T>;
export const useFiltersContext = <T = unknown,>() => {
  const context = useContext<ContextProp<T>>(FiltersContext as Context<ContextProp<T>>);
  if (!context) {
    // isEmpty removed because we have some problems with init that context on contractor -> order tab
    throw new Error('useFiltersContext must be used within a FiltersContext');
  }
  return context;
};
